module.exports = __webpack_public_path__ + "img/sim-card.88b824dc.svg";